import React, {useEffect, useState} from "react";

import {Button, Card, Col, Modal, Row, Stack} from "react-bootstrap";

import TableList from "../../components/table/TableList";
import DropdownBar from "../../components/elements/DropdownBar";
import tableDataSubmissions from "../../controller/tableDataSubmissions";
import tableDataModules from "../../controller/tableDataModules";
import { useParams} from "react-router-dom";
import {StudentListUploader} from "../../components/StudentListUploader";
import {StudentAddToList} from "../../components/StudentAddToList";
import {StudentForceSubmit} from "../../components/StudentForceSubmit";
import { useOutletContext } from 'react-router-dom';
import axios from "axios";

function Students() {
    let { caseid } = useParams();
    const [row,setRow] = useState([]);



    const [fYear, setfYear] = useState("all");
    const [fVD, setfVD] = useState('all');
    const [fSub,setSub] = useState('all');
    const [addStudentModalShown, setAddStudentModalShown] = useState(false);
    const [uploadForceModalShown, setUploadForceModalShown] = useState(false);
    const [subPerStudent, setSubPerStudent] = useState({});

function resetFilters() {
    setfYear('all');
    setfVD('all');
    setSub('all');
}

function removeStudent(removeCase){
    // eslint-disable-next-line no-restricted-globals
    if(confirm("Remove student "+ uploadForceModalShown)){
        axios.delete(`/api/case/${caseid}/removeStudent/${uploadForceModalShown}?removeFromCase=`+removeCase).then(response=>{
            handleCloseForceUpload();
            loadSubmissions()
        })
    }
}

    const context = useOutletContext();

    const handleClose = () => {loadSubmissions();setAddStudentModalShown(false);}
    const handleShow = () => setAddStudentModalShown(true);

    const handleCloseForceUpload = () => {setUploadForceModalShown(null);}

    // const handleDeleteStudent = () => {setUploadForceModalShown(null);}
    // eslint-disable-next-line
    useEffect(()=>{
        loadSubmissions();
        // eslint-disable-next-line
    },[fYear,fVD,fSub,caseid]);

    function loadSubmissions(){
        tableDataModules.getSubmissions(caseid).then((res)=>{
            let rowdata = [];
            let subPerStudent = {}
            for (let i = 0; i < res.length; i++) {
                let subm = res[i];
                if(fYear !== "all")
                    if(subm.year !== parseInt(fYear)) continue;
                if(fVD !== "all")
                    if(subm.fulltime !== (fVD === 'v')) continue;
                if(fSub !== "all")
                    if((subm.submissions.length > 0) !== (fSub === '0')) continue;


                let score = "";
                let date  = "";
                if(subm.submissions.length > 0){
                    let lastsub = subm.submissions[subm.submissions.length-1];
                    score = lastsub.score+"/100";
                    // Pass the timestamp directly for sorting, TableTypeDate will handle formatting
                    date = lastsub.createdOn;
                    subPerStudent[subm.studentNumber] = lastsub.id;
                }

                rowdata.push([
                    subm.studentNumber,
                    subm.firstName + " " + subm.lastName,
                    subm.year,
                    subm.fulltime ? "V" : "D",
                    score,
                    date
                ])
            }
            setSubPerStudent(subPerStudent);
            setRow(rowdata);
            // console.log(rowdata);
        })
    }

    function selectedStudent(index,val) {
        setUploadForceModalShown(val[0]);
    }
    return(
        <>
            <Col xs={{span: 9}}>
                <Card >
                    <Card.Body>
                        <h4>Submissions</h4>
                        <TableList selected={selectedStudent} columnData={tableDataSubmissions.columnData} rowData={row}/>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={{span: 2}} className="p-0">
                <Card >
                    <Card.Body>
                        <Stack gap={3}>
                            <Button style={{width: "100%"}} onClick={handleShow} variant="success">Add Student</Button>
                            <DropdownBar value={fYear} onchange={setfYear} option={{all: "All years",1: "1", 2: "2", 3: "3", 4: "4",5:"5"}}/>
                            <DropdownBar value={fVD} onchange={setfVD} option={{all: "All in VD", v:'V',d:'D'}}/>
                            <DropdownBar option={{1: "MBRT20"}}/>
                            <DropdownBar value={fSub} onchange={setSub} option={{all: "All",0: "Submitted",1: "Unsubmitted"}}/>
                            <Button onClick={resetFilters} className="w-100" variant="outline-secondary">Reset</Button>
                        </Stack>

                    </Card.Body>
                </Card>
                <hr/>
                {/*<Card >*/}
                {/*    <Card.Body>*/}
                {/*        <Stack gap={3}>*/}
                {/*            <b>Avg. student deviations</b>*/}
                {/*            <table>*/}
                {/*                <thead>*/}
                {/*                    <tr>*/}
                {/*                        <th>Name</th>*/}
                {/*                        <th>Distance</th>*/}
                {/*                    </tr>*/}
                {/*                </thead>*/}
                {/*                <tbody>*/}
                {/*                    <tr>*/}
                {/*                        <td>Lung_R</td>*/}
                {/*                        <td>101.25mm</td>*/}
                {/*                    </tr>*/}
                {/*                </tbody>*/}
                {/*            </table>*/}
                {/*        </Stack>*/}

                {/*    </Card.Body>*/}
                {/*</Card>*/}
            </Col>
            <Modal show={addStudentModalShown} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add students</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row><StudentAddToList cb={handleClose}/></Row>
                    <Row><StudentListUploader cb={handleClose}/></Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={uploadForceModalShown} onHide={handleCloseForceUpload}>
                <Modal.Header closeButton>
                    <Modal.Title>Add student submission for </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <StudentForceSubmit student={uploadForceModalShown} case={context[0]} cb={handleCloseForceUpload}/>
                </Modal.Body>
                {subPerStudent[uploadForceModalShown] != null && (
                    <Modal.Body>
                        <Button variant="primary" style={{ width: "100%" }} target="_blank" href={"/student/" + uploadForceModalShown + "/submission/" + subPerStudent[uploadForceModalShown]}>
                            View submission
                        </Button>
                    </Modal.Body>
                )}
                <Modal.Body>
                    <Button variant="danger"  style={{width: "100%"}} onClick={()=>removeStudent(false)}>
                        Delete student submissions
                    </Button>
                    <Button className="mt-2" variant="danger"  style={{width: "100%"}} onClick={()=>removeStudent(true)}>
                        Delete student from case
                    </Button>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="secondary" onClick={handleCloseForceUpload}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Students;